const About = () => {
    return ( 
        <div>
        <div className="section techwix-about-section-07 section-padding">
            <div className="shape-1"></div>
            <div className="container">
                <div className="about-wrap">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="about-img-wrap">
                                <img className="shape-1" src="assets/images/shape/about-shape2.png" alt="" />
                                <div className="about-img">
                                    <img src="assets/images/about-3.jpg" alt="" />
                                </div>
                                <div className="about-img about-img-2">
                                    <img src="assets/images/about-4.jpg" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6" style={{textAlign: "left"}}>
                            <div className="about-content-wrap">
                                <div className="section-title">
                                    <h3 className="sub-title">Who we are</h3>
                                    <h2 className="title">Your vision, our expertise: Tailored IT services.</h2>
                                </div>
                                <p className="text">The Michaels Technologies <b>(TMT)</b> is a fast rising digital and technology company, 
                                a Nigeria indigenous technological company whose operation base resides in Bonny Island, River State,
                                but not restricted to Bonny, but currently have staff working remotely across the globe.</p>
                                <div className="about-list-03">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="about-list-item-03">
                                                <h3 className="title">Our Mission</h3>
                                                <ul style={{listStyle: "square"}}>
                                                    <li>Technological and digital innovations.</li>
                                                    <li>Creating premium technological products</li>
                                                    {
                                                    //<li>Create a rich base of satisfied workers, client & partners</li>
                                                    }
                                                    <li>Delivery excellent IT technology and digital services</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="about-list-item-03">
                                                <h3 className="title">Vision</h3>
                                                <ul  style={{listStyle: "square"}}>
                                                    <li>Top 5 global IT & Digital Technology company.</li>
                                                    <li>Simplify life through digital innovation</li>
                                                    <li>A people-centric global tech leader.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="section techwix-counter-section-03 techwix-counter-section-04">
            <div className="container">
                <div className="counter-wrap" style={{backgroundImage: "url(assets/images/bg/counter-bg2.jpg)"}}>
                    <div className="row">
                        <div className="col-lg-3 col-sm-6">
                            <div className="single-counter-02 text-center">
                                <span>20+</span>
                                <p>Completed Projects</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="single-counter-02 text-center">
                                <span>10+</span>
                                <p>Happy Clients</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="single-counter-02 text-center">
                                <span>5</span>
                                <p>Skilled Experts</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="single-counter-02 text-center">
                                <span>20+</span>
                                <p>Clients Supoort Done</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
     );
}
 
export default About;